import { ReactComponent as CancelSvg } from '../../assets/icons/cancel.svg';

export const CancelIcon: SvgIcon = (props) => {
    return <CancelSvg {...props} />;
};
